Page['fale-conosco-section'] = () => {
	const wrapper = $('.fc-section-v1-fale-conosco');
	wrapper.find('.fc-section-v1-fale-conosco-map-link a')
		.on('click', e => {
			e.preventDefault();
			wrapper.toggleClass('show-map')
			return false
		})
}
